import React, { useState } from 'react';
import { TextField, Button, Box, Alert } from '@mui/material';
import AuthShell from './AuthShell';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage('');
    setError('');

    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Se ha enviado un correo electrónico con instrucciones para restablecer tu contraseña.');
      } else {
        setError(data.message || 'Ha ocurrido un error. Por favor, inténtalo de nuevo más tarde.');
      }
    } catch (error) {
      setError('Error al conectar con el servidor');
    }
  };

  return (
    <AuthShell eyebrow="RECUPERA TU ACCESO" title="¿Olvidaste la contraseña?" subtitle="Te enviaremos un enlace seguro para crear una nueva." compact>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Correo Electrónico"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {message && <Alert severity="success" sx={{ mt: 2 }}>{message}</Alert>}
          {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Enviar correo de restablecimiento
          </Button>
        </Box>
    </AuthShell>
  );
}

export default ForgotPassword;
